import { createContext, ReactElement, ReactNode, useState } from "react";

import { SupportedLanguages } from "../utils/lang";

type LangProviderContextType = {
  lang: SupportedLanguages;
};

export const LangProviderContext = createContext<LangProviderContextType>({
  lang: SupportedLanguages.DEFAULT,
});

type Props = {
  children: ReactNode;
};

export default function LangProvider(props: Props): ReactElement {
  const { children } = props;

  const [lang] = useState<SupportedLanguages>(SupportedLanguages.DEFAULT);

  return (
    <LangProviderContext.Provider value={{ lang }}>
      {children}
    </LangProviderContext.Provider>
  );
}
